import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { $cardUsersStore } from '@lib/store';
import type { UserResponse } from '@shared/api';
import { Button, Modal, Select } from '@shared/widgets';

interface IForm {
  user: string;
}
const DEFAULT_VALUES: IForm = { user: '' };

interface AddUsersModalProps {
  show: boolean;
  onClose: () => void;
  cardId: number;
  usersList: UserResponse[];
}

export const AddUsersModal = (props: AddUsersModalProps) => {
  const { t } = useTranslation('card');
  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });

  const closeHandler = () => {
    props.onClose();
    reset(DEFAULT_VALUES);
  };
  const submitHandler = async (data: IForm) => {
    await $cardUsersStore.events.addUsersInCard({ userIds: data.user, cardIds: [props.cardId] });
    closeHandler();
  };

  return (
    <Modal isOpen={props.show} onClose={closeHandler} className='rounded-lg' title={t('users.modals.addUsers.title')}>
      <form className='flex flex-col gap-6' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='user'
          control={control}
          rules={{ required: t('errors.form.required', { ns: 'common' }) }}
          render={({ field, fieldState: { error } }) => (
            <Select
              nullValue={{ isEnable: false, text: t('placeholders.selectUser', { ns: 'common' }) }}
              items={props.usersList.filter((user) => !user.locked).map((user) => ({ value: user.id, label: `${user.firstName} ${user.lastName}` }))}
              required
              error={error?.message}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <Button fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
          {t('buttons.add', { ns: 'common' })}
        </Button>
      </form>
    </Modal>
  );
};
